// Rod Builder Settings Loader
// Loads config from rod-builder-settings.json and applies to builder

async function loadRodBuilderSettings() {
  try {
    if (!window.ROD_BUILDER_SETTINGS_JSON_URL) {
      throw new Error('ROD_BUILDER_SETTINGS_JSON_URL is not defined on window. Make sure it is injected by Liquid.');
    }
    const response = await fetch(window.ROD_BUILDER_SETTINGS_JSON_URL);
    if (!response.ok) throw new Error('Settings file not found at ' + window.ROD_BUILDER_SETTINGS_JSON_URL);
    const settings = await response.json();
    window.rodBuilderSettings = settings;
    return settings;
  } catch (e) {
    console.warn('Could not load rod-builder-settings.json:', e);
    return null;
  }
}

// Use settings for slot types, icons, and defaults
async function getSlotTypesFromSettings() {
  const settings = window.rodBuilderSettings || await loadRodBuilderSettings();
  if (settings && Array.isArray(settings.slotTypes)) {
    return settings.slotTypes.map(slot => ({
      type: slot.type,
      icon: slot.icon,
      title: slot.defaultTitle || slot.type
    }));
  }
  // Fallback to hardcoded defaults
  return DEFAULT_SLOT_TYPES;
}

// Override getDefaultSlots to use config
async function getDefaultSlots() {
  const slotTypes = await getSlotTypesFromSettings();
  return slotTypes.map(slot => ({
    slotId: generateUniqueSlotId(slot.title),
    type: slot.type,
    icon: slot.icon,
    title: slot.title
  }));
}

// On DOMContentLoaded, load settings before rendering slots
window.addEventListener('DOMContentLoaded', async function() {
  await loadRodBuilderSettings();
  // ...existing code...
});
